import { render } from "./Close.vue?vue&type=template&id=651c8ac3&scoped=true"
const script = {}

import "./Close.vue?vue&type=style&index=0&id=651c8ac3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651c8ac3"]])

export default __exports__